<template>
  <div class="school-system-permissions">
    <el-form :inline="true" class="form-style" size="small">
      <el-form-item label="合同名称">
        <el-input
          v-model="title"
          placeholder="请输入合同名称"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-button size="mini" @click="search" type="primary">查询</el-button>
      </el-form-item>
      <el-button size="mini" @click="add" type="primary" icon="el-icon-plus"
        >添加合同</el-button
      >
    </el-form>
    <div style="margin-top: 20px">
      <el-table
        size="mini"
        :data="tableData"
        :header-cell-style="{ background: '#f5f7fa' }"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column align="center" width="50" label="序号">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 + 20 * (page_no - 1) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="合同名称"></el-table-column>
        <el-table-column prop="start_date" label="签约日期"></el-table-column>
        <el-table-column prop="end_date" label="截止日期"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="edit(scope.row)">编辑</el-button>
            <el-button type="text" @click="del(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-style">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="page_no"
        :page-size="page_size"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>

    <!-- 添加合同 -->
    <el-dialog title="提示" :visible.sync="dialogVisible" width="50%">
      <el-form
        ref="form"
        label-width="70px"
        :model="form"
        size="mini"
        label-position="left"
      >
        <el-form-item label="标题">
          <el-input
            v-model="form.title"
            placeholder="请输入标题"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="日期">
          <el-date-picker
            v-model="form.data"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            placement="bottom-start"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="上传附件">
          <el-upload
            action=""
            :http-request="uploadFile"
            :on-remove="handleRemove1"
            :on-change="handleChangeFile3"
            :on-exceed="handleExceed"
            :limit="1"
            :file-list="form.pptList"
            list-type="text"
            style="width: 300px"
          >
            <el-button size="mini" type="primary" plain
              >点击上传<i class="el-icon-upload el-icon--right"></i
            ></el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传pdf 格式
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  adminAddOrUpdateContract,
  adminGetContract,
  adminDeleteContract,
} from '@/api/admin'
import uploadFile from '@/config/uploadFile'

export default {
  name: 'school-system-permissions',
  data() {
    return {
      title: '',
      dialogVisible: false,
      form: {
        title: '',
        data: [],
        pptList: [],
      },
      page_no: 1,
      total: 0,
      page_size: 10,
      tableData: [],
    }
  },
  computed: {},
  mounted() {
    this.adminGetContract()
  },

  methods: {
    //删除
    del(row) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          adminDeleteContract({
            contractId: row.id,
          }).then(() => {
            this.adminGetContract()
            this.$message({
              type: 'success',
              message: '删除成功!',
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    //获取列表
    adminGetContract() {
      adminGetContract({
        schoolId: this.$route.query.id,
        title: this.title,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log(res)
        this.tableData = res.contactList
      })
    },
    search() {
      this.page_no = 1
      this.adminGetContract()
    },
    handleCurrentChange(val) {
      this.page_no = val
      this.adminGetContract()
    },
    add() {
      this.form.contractId = ''
      this.form.title = ''
      this.form.data = []
      this.form.fileUrl = ''
      this.form.pptList = []
      this.dialogVisible = true
    },
    edit(row) {
      this.form.data = []
      this.form.pptList = []
      this.form.contractId = row.id
      this.form.title = row.title
      this.form.data.push(row.start_date)
      this.form.data.push(row.end_date)
      this.form.data.join(',')
      this.form.fileUrl = row.file_url
      this.form.pptList.push({
        name: row.title,
        url: row.file_url,
      })

      this.dialogVisible = true
    },
    // 添加
    submit() {
      if (this.form.contractId === '') {
        adminAddOrUpdateContract({
          schoolId: this.$route.query.id,
          title: this.form.title,
          startDate: this.form.data[0],
          endDate: this.form.data[1],
          fileUrl: this.form.fileUrl,
        }).then((res) => {
          console.log(res)
          this.adminGetContract()
          this.dialogVisible = false
          this.$message({
            message: '添加成功',
            type: 'success',
          })
        })
      } else {
        adminAddOrUpdateContract({
          contractId: this.form.contractId,
          schoolId: this.$route.query.id,
          title: this.form.title,
          startDate: this.form.data[0],
          endDate: this.form.data[1],
          fileUrl: this.form.fileUrl,
        }).then((res) => {
          console.log(res)
          this.adminGetContract()
          this.dialogVisible = false
          this.$message({
            message: '编辑成功',
            type: 'success',
          })
        })
      }
    },
    uploadFile() {},
    handleRemove1(file, fileList) {
      console.log(fileList)

      this.form.pptList = []
    },
    //课件上传
    async handleChangeFile3(file, fileList) {
      console.log(file, 456)
      var FileExt = file.name.replace(/.+\./, '')
      if (['pdf', 'PDF'].indexOf(FileExt.toLowerCase()) === -1) {
        this.$message({
          type: 'warning',
          message: '请上传后缀名为pdf的附件！',
        })
        return false
      } else {
        console.log('上传课程课件')
        var status = 'course_ppt'
        if (!this.uploadFileTime) {
          await this.uploadFileOss(fileList, status)
        }
      }
    },
    async uploadFileOss(list) {
      this.uploadFileTime = true
      await uploadFile(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          console.log('上传文件')
          console.log(res)
          res.map((item) => {
            this.form.fileUrl = item.url
          })
          this.uploadFileTime = false
        }
      )
    },
    handleExceed() {
      this.$message.warning('请删除原有文件,再重新上传')
    },
  },
}
</script>

<style scoped lang="scss">
.school-system-permissions {
  height: 100%;
  background-color: #fff;
  padding-top: 5px;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 15px;
  margin: 10px;
  border-radius: 5px;

  .form-style {
  }

  .table-style {
  }
}
</style>
